// NotFoundPage.jsx
import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: 'grey.100',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        {/* Optional illustration */}
        <Box
          component="img"
          src="https://illustrations.popsy.co/gray/falling.svg"
          alt="Not found illustration"
          sx={{ width: '100%', maxWidth: 400, mb: 4 }}
        />

        <Typography variant="h3" gutterBottom>
          Página no encontrada
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Lo sentimos, la página que buscas no existe o fue movida.  
          Verifica la dirección o regresa al inicio.
        </Typography>

        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={() => navigate('/')}
        >
          Volver al inicio
        </Button>
      </Container>
    </Box>
  );
};

export default NotFound;
